import { NavbarV2 } from "@/components/landing-v2/NavbarV2";
import { Footer } from "@/components/landing/Footer";
import { PricingHero } from "@/components/pricing/PricingHero";
import { PricingCards } from "@/components/pricing/PricingCards";
import { CreditsTable } from "@/components/pricing/CreditsTable";
import { FAQ } from "@/components/pricing/FAQ";
import { ContactSection } from "@/components/pricing/ContactSection";

export function PricingPage() {
  return (
    <div className="bg-background min-h-screen">
      <NavbarV2 />
      <main>
        <PricingHero />
        <PricingCards />
        <CreditsTable />
        <FAQ />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
